import AuthService from '@/services/auth'
import MeService from '@/services/me'
import UserService from '@/services/users'

import router from '@/router/index'
import routeNames from '@/router/routeNames'

export default {
  namespaced: true,
  state: {
    user: null,
    isLogged: false
  },
  getters: {
    isAdmin: state => state.user && state.user.roles.some(role => role === 'ROLE_SUPER_ADMIN'),
    picturePath: state => state.user && state.user.picture ? process.env.VUE_APP_SERVER_ADDRESS + '/files/avatar/' + state.user.picture : null
  },
  mutations: {
    connect: (state) => state.isLogged = true,
    disconnect: (state) => state.isLogged = false,
    loadUser: (state, user) => state.user = user,
    unloadUser: (state) => state.user = null,
  },
  actions: {
    async performLogin ({commit}, payload) {
      const user = await AuthService.login(payload.username, payload.password)
      if (!user.isActive) throw 'inactive'
      commit('loadUser', user)
      commit('connect')
    },
    async disconnectUser ({commit}) {
      await AuthService.logout()
      commit('disconnect')
      commit('unloadUser')
      router.push({name: routeNames.login})
    },
    async reconnect ({commit}) {
      const user = await MeService.getMe()

      if (!user || !user.isActive) return false
      commit('loadUser', user)
      commit('connect')
      return true
    },
    async updatePicture ({state, commit}, payload) {
      const newPicture = (await UserService.updatePicture(state.user.id, payload))
      let user = {...state.user}
      user.picture = newPicture
      commit('loadUser', user)
    }
  }
}